var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconFolder = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5934 3.12356H7.94296C7.54807 3.12356 7.31578 3.01976 7.02542 2.76329L6.67119 2.45187C6.28791 2.11602 5.98594 2 5.41683 2H3.68628C2.67002 2 2.0835 2.61063 2.0835 3.84411V5.4745H15.4168V5.01042C15.4168 3.75251 14.8071 3.12356 13.5934 3.12356ZM3.90696 13.3333H13.7676C14.8129 13.3333 15.4168 12.6983 15.4168 11.4404V6.30496H2.0835V11.4404C2.0835 12.7044 2.69325 13.3333 3.90696 13.3333Z",
    fill: "#E5E4EC"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconFolder);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-folder.216c768a252241c0034d878435ffeb28.svg";